import { cm } from '../../libs/cm';
import { Spinner } from '../widgets/Spinner';

type ButtonProps = {
  isLoading?: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export const Button = ({ className, isLoading, ...rest }: ButtonProps) => {
  const classes = cm(
    'tw-font-bold tw-bg-[#FF5000] tw-text-white tw-rounded-[133.5px] tw-min-w-[7.875rem] tw-min-h-[2.5rem] tw-flex tw-justify-center tw-items-center',
    { 'tw-bg-[#828282]': rest.disabled },
    { 'tw-pointer-events-none': isLoading },
    className
  );

  return (
    <div
      className={`${
        isLoading
          ? 'tw-cursor-not-allowed'
          : 'hover:tw-opacity-90 tw-transition-opacity'
      }`}
    >
      <button className={classes} {...rest}>
        {isLoading ? (
          <button
            disabled
            className="tw-bg-[#FF5000] tw-flex tw-items-center tw-justify-center  tw-text-[#EBEBEB] tw-font-bold tw-border-[0.1rem] tw-w-[10rem] tw-h-[2.5rem] tw-rounded-3xl"
          >
            <svg
              className="tw-animate-spin tw-h-5 tw-w-5 tw-mr-3 "
              viewBox="0 0 24 24"
            >
              <path
                xmlns="http://www.w3.org/2000/svg"
                d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z"
                className="spinner_P7sC"
                fill="white"
              />
            </svg>
            Processando...
          </button>
        ) : (
          rest.children
        )}
      </button>
    </div>
  );
};
